/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createRangeClass } from '../../factoriesAny.js';
export var RangeDependencies = {
  createRangeClass
};